<template>
    <div class="box">
        <Box :title="$route.params.hiddenTitle?'待接单':'已接单'">
            <FacilityDetails :data="EquipmentInfo"/>
            <Audio :AudioExternal='RepairInfo.AudioUrl'/>
            <RepairsDetails :data="RepairInfo"/>
            
            <div class="explain test" v-if="!$route.params.hiddenTitle">
                <p class="title">转单工程师</p>
                <Field title="维修工程师" placeholder="请选择" type='manufacturer' name='personnel_maintain' :action='true' @manuconfirm="ZPWXRY=arguments[0].a"/>
            </div>
            <ImgModule upload :disabled='true'/>
        </Box>
        <Footer :button="$route.params.hiddenTitle?'接单':'转单'" @change="change"/>
    </div>
</template>

<script>
    import Audio from '../../components/Audio/AudioDefault.vue'
    import Field from '@/components/field/field'
    import Box from '../../components/commonBox/commonBox'
    import Title from '../../components/commonTitle/commonTitle'
    import FacilityDetails from '../../components/facilityDetails/facilityDetails'
    import RepairsDetails from '../../components/repairsDetails/repairsDetails'
    import ImgModule from '../../components/imgModule/imgModule'
    import Footer from '../../components/footer/footer'
    export default {
        name: 'OrderReceiving',
        components: {
            Audio,
            Box,
            Title,
            FacilityDetails,
            RepairsDetails,
            ImgModule,
            Footer,
            Field
        },
        data() {
            return {
                AudioUrl:'',
                EquipmentInfo: this.$route.params.item,
                RepairInfo:{},
                AssignUserId:'',//指派维修工程师
                ZPWXRY:null,//转科维修工程师
                WXDH:this.$route.params.item.RepairOrder||this.$route.params.item.OrderNo,//这里RepairOrder是通过接单列表带过来的
                                                                                          //OrderNo是通过消息页面带过来的
            }
        },
        mounted(){
          this.$get('/api/Repair/GetRepairInfo',{
              RepairNo:this.WXDH,
              Store:this.$UserInfo.UserId,
              Token:'1235'
          }).then(result=>{
              this.RepairInfo=result.RepairInfo;
              const Images=result.RepairInfo.Images?result.RepairInfo.Images.split(','):[];
              let ImageArray=[];
              Images.forEach(function(item,index){
                  item?ImageArray.push({url:item}):'';
              })
              this.$Bus.$emit('YSRKDelete',ImageArray);
          })
        },
        methods: {
            change() {
                if(this.$route.params.hiddenTitle){//接单
                    this.$post('api/PickOrder/CheckOrder',{
                        RepairOrder:this.WXDH,
                        UserCode:this.$UserInfo.UserId,
                        Store:this.$UserInfo.StoreCode,
                        Token:'1234545',
                        }).then(result=>{
                            if(result.Status){
                                if(this.EquipmentInfo.OrderNo)this.$Bus.$emit('Message',this.EquipmentInfo.OrderNo);//需要返回，将列表删除
                                this.$Toast({
                                    message:'接单成功!',
                                    duration:1000,
                                    onClose:()=>{
                                        this.$router.back()
                                    }
                                });
                            }else this.$Toast(result.Msg);
                        })
                }else{
                     if(!this.ZPWXRY){
                         this.$Toast('请选择转单维修工程师!');
                         return false;
                     }
                     if(this.ZPWXRY===this.EquipmentInfo.AssignRepairPeople){
                         this.$Toast('不能转给本人，请重新选择!');
                         return false;
                     }
                     this.$post('api/Dispatch/Assign',{
                         RepairOrder:this.WXDH,
                         UserCode:this.$UserInfo.UserId,
                         AssignUserId:this.ZPWXRY,
                         LineNumber:'1',
                         Store:this.$UserInfo.StoreCode,
                         EquCode:this.EquCode,
                         RepairStatus:'2',
                         Token:'1234'
                     }).then(result=>{
                         if(result.Status){
                             this.$Toast('转单成功!');
                             setTimeout(x=>{
                                 this.$router.go(-1);
                             },2000)
                         }else this.$Toast(result.Msg);
                     })

                }

            }
        }
    }
</script>

<style scoped lang="scss">
    .box{
        padding-bottom: 114px;
    }

    .explain {
        input {
            width: 100%;
            text-align: left;
            margin: 20px 0 48px;
        }
    }
    .test {
    background: $BACKGROUND-COLOR;
    border-radius: 12px;
    padding: 34px 40px 0;
    box-sizing: border-box;
    margin-bottom: 20px;
    p{
        font-size: 4.533vw;
        font-weight: bold;
        color: #14171a;
        margin-bottom: 4vw;
    }
    }
</style>



// WEBPACK FOOTER //
// src/page/orderReceiving/orderReceiving.vue